"use client";
import React from "react";
import { cn } from "@/lib/utils";

/**
 * BackgroundBeams — CSS-only version
 * Replaces the old framer-motion version (46 animated SVG paths)
 * with lightweight CSS keyframe animations for ~150KB bundle savings.
 */
export const BackgroundBeams = ({ className }) => {
    return (
        <div
            className={cn(
                "absolute h-full w-full inset-0 bg-background overflow-hidden pointer-events-none transition-colors duration-300",
                className
            )}
        >
            {/* Radial mask for soft edges */}
            <div className="absolute inset-0 [mask-image:radial-gradient(ellipse_at_center,rgba(0,0,0,0.3),#000)]">
                {/* Animated beam lines using CSS only */}
                {Array.from({ length: 12 }, (_, i) => (
                    <div
                        key={i}
                        className="beam-line"
                        style={{
                            '--beam-delay': `${i * 1.2}s`,
                            '--beam-duration': `${8 + (i % 4) * 2}s`,
                            '--beam-left': `${-10 + i * 10}%`,
                            '--beam-angle': `${55 + (i % 3) * 5}deg`,
                            '--beam-opacity': `${0.08 + (i % 3) * 0.04}`,
                        }}
                    />
                ))}
            </div>

            {/* Subtle gradient overlay */}
            <div className="absolute inset-0 bg-gradient-to-r from-transparent via-background to-transparent h-full w-full opacity-20 transition-colors duration-300" />

            <style>{`
                .beam-line {
                    position: absolute;
                    top: -50%;
                    left: var(--beam-left);
                    width: 1px;
                    height: 200%;
                    background: linear-gradient(
                        to bottom,
                        transparent 0%,
                        transparent 40%,
                        rgba(234, 88, 12, var(--beam-opacity)) 50%,
                        transparent 60%,
                        transparent 100%
                    );
                    transform: rotate(var(--beam-angle));
                    animation: beam-sweep var(--beam-duration) ease-in-out var(--beam-delay) infinite;
                    opacity: 0;
                }

                @keyframes beam-sweep {
                    0% {
                        opacity: 0;
                        transform: rotate(var(--beam-angle)) translateY(-30%);
                    }
                    15% {
                        opacity: 1;
                    }
                    50% {
                        opacity: 1;
                        transform: rotate(var(--beam-angle)) translateY(0%);
                    }
                    85% {
                        opacity: 1;
                    }
                    100% {
                        opacity: 0;
                        transform: rotate(var(--beam-angle)) translateY(30%);
                    }
                }
            `}</style>
        </div>
    );
};
